/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_IntroInputs */

const en_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesson packages, range ball buckets, and gift cards. Prices shown as cash / card.`)
};

const es_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquetes de lecciones, cubetas de pelotas y tarjetas de regalo. Precios mostrados como efectivo / tarjeta.`)
};

const de_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterrichtspakete, Rangeball-Eimer und Geschenkkarten. Preise jeweils bar / mit Karte.`)
};

const zh_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程套餐、练习场球桶和礼品卡。价格按现金/刷卡显示。`)
};

const ar_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باقات دروس، سلال كرات الميدان، وبطاقات هدايا. الأسعار معروضة نقداً / ببطاقة.`)
};

const fr_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forfaits de cours, seaux de balles de golf et cartes-cadeaux. Prix indiqués en espèces/carte.`)
};

const vi_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói bài học, xô bóng sân tập, và thẻ quà tặng. Giá hiển thị theo tiền mặt / thẻ.`)
};

const sw_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vifurushi vya masomo, ndoo za mipira ya uwanja wa mazoezi, na kadi za zawadi. Bei zinaonyeshwa kwa pesa taslimu / kadi.`)
};

const th_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็กเกจบทเรียน ถังลูกกอล์ฟสำหรับสนามไดร์ฟ และบัตรของขวัญ ราคาที่แสดงเป็นเงินสด/บัตร`)
};

const bs_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketi lekcija, kante loptica i poklon kartice. Cijene prikazane kao gotovina / kartica.`)
};

const ja_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンパッケージ、レンジボールバケット、ギフトカード。現金／カード価格を表示。`)
};

const ko_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 패키지, 레인지 볼 버킷, 기프트 카드. 현금/카드 가격 표시.`)
};

const pt_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacotes de aulas, baldes de bolas para o driving range e cartões-presente. Preços em dinheiro / cartão.`)
};

const it_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacchetti di lezioni, cestini di palline per il campo pratica e carte regalo. Prezzi in contanti / carta.`)
};

const sv_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektionspaket, bollhinkar för drivingrangen och presentkort. Priserna visas som kontant / kort.`)
};

const nl_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lespakketten, ballenemmers voor de driving range en cadeaukaarten. Prijzen contant / per kaart.`)
};

const da_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektionspakker, boldkurve til drivingrangen og gavekort. Priserne er vist som kontant / kort.`)
};

const nb_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timepakker, ballkurver til drivingrangen og gavekort. Prisene er oppgitt som kontant / kort.`)
};

const fi_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntipaketteja, rangen palloämpäreitä ja lahjakortteja. Hinnat käteisellä / kortilla.`)
};

const pl_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakiety lekcji, koszyki piłek na driving range i karty podarunkowe. Ceny podane za gotówkę / kartę.`)
};

const ru_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакеты уроков, корзины мячей для драйвинг-рейнджа и подарочные карты. Цены указаны за наличные / по карте.`)
};

const tr_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders paketleri, driving range top kovaları ve hediye kartları. Fiyatlar nakit / kart içindir.`)
};

const hi_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ पैकेज, रेंज बॉल बाल्टी और उपहार कार्ड। मूल्य नकद / कार्ड के रूप में दिखाया गया है।`)
};

const id_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket pelajaran, ember bola driving range, dan kartu hadiah. Harga ditampilkan untuk tunai / kartu.`)
};

const ms_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakej pelajaran, baldi bola latihan dan kad hadiah. Harga ditunjukkan sebagai tunai / kad.`)
};

const cs_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balíčky lekcí, košíky míčků na driving range a dárkové karty. Ceny jsou uvedeny za hotovost / kartu.`)
};

const el_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πακέτα μαθημάτων, κουβάδες με μπάλες για το driving range και δωροκάρτες. Οι τιμές εμφανίζονται για μετρητά / κάρτα.`)
};

const he_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חבילות שיעורים, דליי כדורים למגרש האימונים וכרטיסי מתנה. המחירים מוצגים במזומן / בכרטיס.`)
};

const af_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lespakkette, balemmers en geskenkkaarte. Pryse getoon as kontant / kaart.`)
};

const hu_prices_intro = /** @type {(inputs: Prices_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óracsomagok, labdakosarak a driving range-re és ajándékkártyák. Az árak készpénzes / kártyás fizetésre vonatkoznak.`)
};

/**
* | output |
* | --- |
* | "Lesson packages, range ball buckets, and gift cards. Prices shown as cash / card." |
*
* @param {Prices_IntroInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_intro = /** @type {((inputs?: Prices_IntroInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_IntroInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_intro(inputs)
	if (locale === "de") return de_prices_intro(inputs)
	if (locale === "zh") return zh_prices_intro(inputs)
	if (locale === "ar") return ar_prices_intro(inputs)
	if (locale === "fr") return fr_prices_intro(inputs)
	if (locale === "vi") return vi_prices_intro(inputs)
	if (locale === "sw") return sw_prices_intro(inputs)
	if (locale === "th") return th_prices_intro(inputs)
	if (locale === "bs") return bs_prices_intro(inputs)
	if (locale === "ja") return ja_prices_intro(inputs)
	if (locale === "ko") return ko_prices_intro(inputs)
	if (locale === "pt") return pt_prices_intro(inputs)
	if (locale === "it") return it_prices_intro(inputs)
	if (locale === "sv") return sv_prices_intro(inputs)
	if (locale === "nl") return nl_prices_intro(inputs)
	if (locale === "da") return da_prices_intro(inputs)
	if (locale === "nb") return nb_prices_intro(inputs)
	if (locale === "fi") return fi_prices_intro(inputs)
	if (locale === "pl") return pl_prices_intro(inputs)
	if (locale === "ru") return ru_prices_intro(inputs)
	if (locale === "tr") return tr_prices_intro(inputs)
	if (locale === "hi") return hi_prices_intro(inputs)
	if (locale === "id") return id_prices_intro(inputs)
	if (locale === "ms") return ms_prices_intro(inputs)
	if (locale === "cs") return cs_prices_intro(inputs)
	if (locale === "el") return el_prices_intro(inputs)
	if (locale === "he") return he_prices_intro(inputs)
	if (locale === "af") return af_prices_intro(inputs)
	if (locale === "hu") return hu_prices_intro(inputs)
	return en_prices_intro(inputs)
});